import * as React from 'react'
import PropTypes from 'prop-types'

import {
  TextContainer,
  Headline,
  Container
} from './style'
const ArticleBlockHeadline = ({
  text = '',
  alignment = 'left'
}) => {
  return (
    <Container>
      <TextContainer isLarge={ alignment === 'center' }>
        <Headline alignment={ alignment }>
          { text }
        </Headline>
      </TextContainer>
    </Container>
  )
}

ArticleBlockHeadline.propTypes = {
  text: PropTypes.string,
  alignment: PropTypes.string
}

export default ArticleBlockHeadline
